if (!customElements.get('amare-collection-page')) {
  customElements.define('amare-collection-page', class extends HTMLElement {
    connectedCallback() {
      this.buttons = [...this.querySelectorAll('[data-collection-filter]')];
      this.status = this.querySelector('[data-collection-count]');
      this.buttons.forEach((button) => button.addEventListener('click', () => this.filter(button, true)));
      this.observeProductGrid();
      this.resetModelFilter();
    }

    disconnectedCallback() {
      this.productGridObserver?.disconnect();
    }

    get cards() {
      return [...this.querySelectorAll('[data-collection-card]')];
    }

    observeProductGrid() {
      const productGrid = this.querySelector('#ProductGridContainer');
      if (!productGrid) return;
      this.productGridObserver = new MutationObserver(() => this.resetModelFilter());
      this.productGridObserver.observe(productGrid, { childList: true, subtree: true });
    }

    resetModelFilter() {
      const allButton = this.buttons.find((button) => button.dataset.collectionFilter === 'all');
      const requestedModel = new URL(window.location.href).searchParams.get('model');
      const requestedButton = this.buttons.find((button) => button.dataset.collectionFilter === requestedModel);
      this.filter(requestedButton || allButton, false);
    }

    filter(activeButton, updateUrl = false) {
      if (!activeButton) return;
      const filter = activeButton.dataset.collectionFilter;
      let visible = 0;
      this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(button === activeButton)));
      this.cards.forEach((card) => {
        const show = filter === 'all' || card.dataset.model === filter;
        card.hidden = !show;
        if (show) visible += 1;
      });
      this.updateCount(visible);
      if (updateUrl) {
        const url = new URL(window.location.href);
        if (filter === 'all') url.searchParams.delete('model');
        else url.searchParams.set('model', filter);
        window.history.replaceState(window.history.state, '', url);
      }
    }

    updateCount(count) {
      if (!this.status) return;
      this.status.textContent = `${count} ${count === 1 ? this.dataset.modelSingular : this.dataset.modelPlural}`;
    }
  });
}

if (!customElements.get('amare-shoe-card')) {
  customElements.define('amare-shoe-card', class extends HTMLElement {
    connectedCallback() {
      this.swatches = [...this.querySelectorAll('[data-shoe-color-swatch]')];
      this.swatches.forEach((swatch) => swatch.addEventListener('click', () => this.selectColor(swatch)));
    }

    selectColor(swatch) {
      const image = this.querySelector('[data-shoe-card-image]');
      const color = this.querySelector('[data-shoe-card-color]');
      const currentPrice = this.querySelector('[data-shoe-card-price]');
      const comparePrice = this.querySelector('[data-shoe-card-compare]');
      const links = this.querySelectorAll('[data-shoe-card-link]');

      this.swatches.forEach((item) => {
        const active = item === swatch;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (image && swatch.dataset.image) {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = swatch.dataset.image;
        image.alt = swatch.dataset.imageAlt || image.alt;
      }
      if (color) color.textContent = swatch.dataset.color || '';
      if (currentPrice) currentPrice.textContent = swatch.dataset.price || '';
      if (comparePrice) {
        comparePrice.textContent = swatch.dataset.compareAt || '';
        comparePrice.hidden = swatch.dataset.onSale !== 'true';
      }
      links.forEach((link) => {
        if (swatch.dataset.variantUrl) link.href = swatch.dataset.variantUrl;
      });
    }
  });
}
